import type { GroupSchema } from '../types';
import type { Section } from '../models/Section';
import { useFormContext } from '../context/FormContext';
import { FieldRenderer } from './FieldRenderer';

export function GroupView({
  groupSchema,
  section,
  index,
}: {
  groupSchema: GroupSchema;
  section: Section;
  index: number;
}) {
  const { displayService } = useFormContext();

  const group = section.groups.find((g) => g.id === groupSchema.id && g.index === index);

  if (!group || !displayService.showGroup(group)) {
    return null;
  }

  return (
    <div className="group">
      {groupSchema.showTopDivider !== false && <hr className="pull-right" />}
      {group.label && <h4>{group.label}</h4>}
      {groupSchema.fields.map((fieldSchema) => (
        <FieldRenderer key={`${fieldSchema.id}-${index}`} fieldSchema={fieldSchema} group={group} />
      ))}
    </div>
  );
}
